import { useMediaQuery } from "@mui/material";
import theme from "assets/theme";
import LoadingOverlay from "components/LoadingOverlay";
import SimpleSideNav from "components/Sidenav/SimpleSideNav";
import { useAuth } from "context/Auth";
import { ReactNode } from "react";

interface Props {
  children?: ReactNode;
  loading?: boolean;
}

const BasicLayout: React.FC<Props> = ({ children, loading = false }: Props) => {
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("lg"));

  const { hasSubscription } = useAuth();

  return (
    <>
      <div
        className="flex flex-row w-full h-screen overflow-hidden"
        style={{ paddingTop: !isLargeScreen ? "65px" : "0" }}
      >
        <SimpleSideNav />
        <LoadingOverlay loading={loading} />
        <main
          className="flex-grow p-3 overflow-x-hidden overflow-y-auto h-full flex flex-col"
          style={{ margin: isSmallScreen ? 0 : "0px 20px 20px 20px" }}
        >
          {!hasSubscription ? (
            <div className="grid grid-cols-1 gap-4">
              <div>
                <h1 className="text-2xl font-semibold">No subscription</h1>
              </div>
              <div>
                <a
                  href="/plans"
                  className="inline-block px-4 py-2 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700"
                >
                  Go to plans
                </a>
              </div>
            </div>
          ) : (
            children
          )}
        </main>
      </div>
    </>
  );
};

export default BasicLayout;
